// Parses the masterlist "spec" string ("Key: Value\nKey: Value") into rows.
function parseSpec(spec) {
  if (!spec) return [];
  return spec
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const idx = line.indexOf(":");
      if (idx === -1) return { label: line, value: "" };
      return { label: line.slice(0, idx).trim(), value: line.slice(idx + 1).trim() };
    });
}

function SpecRow({ label, value }) {
  return (
    <>
      <span className="font-bold text-gray-900 text-sm whitespace-nowrap leading-snug">
        {label}:
      </span>
      <span className="text-gray-700 text-sm leading-snug">{value}</span>
    </>
  );
}

function Block({ heading, item }) {
  if (!item) return null;
  const rows = parseSpec(item.spec);
  return (
    <div className="flex-1 min-w-[240px]">
      <div className="flex items-start justify-between gap-4 mb-3">
        <div>
          <h3 className="text-xl font-black text-gray-900 tracking-tight uppercase">
            {heading}
          </h3>
          <p className="text-xs text-gray-600 mt-1 leading-snug">{item.name}</p>
        </div>
        <div className="shrink-0">
          <p className="text-[10px] text-gray-400 tracking-widest uppercase mb-1">
            Article No
          </p>
          <div className="bg-gray-600 text-white font-bold text-sm px-4 py-1.5 text-center">
            {item.id}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-[max-content_1fr] gap-x-4 gap-y-0.5">
        {rows.map((r, i) => (
          <SpecRow key={i} label={r.label} value={r.value} />
        ))}
      </div>
    </div>
  );
}

export default function VanityInformationModal({ info, onClose }) {
  if (!info) return null;
  const { countertop, storage } = info;

  return (
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 md:p-6"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-4xl md:rounded-[2.5rem] max-w-3xl w-full p-6 md:p-10 overflow-y-auto max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-col md:flex-row gap-8 md:gap-12">
          <Block heading="Countertop" item={countertop} />
          <Block heading="Storage" item={storage} />
        </div>

        <hr className="border-gray-300 my-6" />

        <p className="text-xs md:text-sm text-gray-500 leading-relaxed">
          Bathroom accessories and sanitary fittings are shown for illustration
          purposes and are excluded from the price. Price includes delivery and
          installation.
        </p>
      </div>
    </div>
  );
}
